import { format, isValid, parse } from 'date-fns';
import * as Flowbite from 'flowbite-react';
import TimePicker from 'react-time-picker';
import { BaseInputProps } from '../types';

const TIME_FORMAT = 'HH:mm';

type TimeInputProps = BaseInputProps<Date> & {
    use12Hour: boolean;
    onChange: (date: Date) => void;
};

export const TimeInput = ({
    use12Hour,
    onChange,
    ['aria-label']: ariaLabel,
    className,
    label,
    name,
    color = 'primary',
    value = new Date(),
}: TimeInputProps) => {
    const timeString = format(value, TIME_FORMAT);

    return (
        <Flowbite.Label
            className="flex flex-col gap-2 font-normal"
            color={color}
        >
            <span className="font-medium">{label}</span>

            <TimePicker
                className={className}
                clearIcon={null}
                clockIcon={null}
                disableClock
                format={use12Hour ? 'aa hh:mm' : 'HH:mm'}
                name={name}
                nativeInputAriaLabel={ariaLabel}
                value={timeString}
                onChange={(time) => {
                    const newDate = parse(time ?? '00:00', TIME_FORMAT, value);
                    if (isValid(newDate)) {
                        onChange(newDate);
                    }
                }}
            />
        </Flowbite.Label>
    );
};
